/* EWA — PDP tam ekran görsel: telefon galerisi motoru
   ═══════════════════════════════════════════════════════════════════════════
   Davranış (yalnız mobil, ≤749px):
     · iki parmak      → yakınlaştır/uzaklaştır; parmakların ortasındaki nokta
                          sabit kalır (fotoğraf parmağa yapışık hissedilir)
     · çift dokunuş    → 1× ↔ 2.5× geçiş; dokunulan nokta sabit kalır
     · yakınken sürükle → gez. Kenara dayanıp aynı yöne devam edilirse fotoğraf
                          değişir — telefon galerilerindeki devir teslim
     · uzakken sürükle  → yatay ray; mesafe VEYA hız eşiği geçilirse sonraki kare

   Zoom ve swipe aynı ekseni paylaşıyor: hangi jestin hangisi olduğu tek bir
   durum makinesinde karara bağlanıyor, iki ayrı dinleyici değil.

   NEDEN DAWN'IN ÜSTÜNE: `product-modal.js` (Dawn) tek bir medyaya `.active`
   koyup gerisini gizliyor. Motor o işaretlemeyi BOZMUYOR — üstüne biniyor:
   `.active` başlangıç karesini söylüyor, ray görünürlüğü CSS'te devralıyor.
   Motor devreye girmezse (masaüstü, video/3D medya, jest desteği yok) modal
   bugünkü haliyle çalışmaya devam eder.

   Motor DEVREYE GİRMEZ: ürünün medyalarından biri bile görsel değilse.
   `showActiveMedia()` video içeriğini `nodeName == 'DEFERRED-MEDIA'` ile
   yüklüyor; o dalı transform rayına sokmak yarım çalışan bir video demek.
   ═══════════════════════════════════════════════════════════════════════════ */

(function () {
  'use strict';

  if (window.__ewaPdpZoom) return;
  window.__ewaPdpZoom = true;

  var MOBILE = window.matchMedia('(max-width: 749px)');

  var MAX_SCALE = 4; /* daha ötesi 4096w kaynakta bile bulanık */
  var TAP_SCALE = 2.5; /* çift dokunuşun açtığı kademe */
  var SWIPE_RATIO = 0.18; /* panel genişliğinin bu oranı = kare değişir */
  var SWIPE_VELOCITY = 0.4; /* px/ms — kısa ama hızlı fiske de saymalı */
  var EDGE_HANDOVER = 44; /* yakınken kenara dayandıktan sonraki devir eşiği */
  var AXIS_LOCK = 8; /* yön kararı için gereken minimum hareket */
  var TAP_SLOP = 12;
  var TAP_MS = 260;
  var DOUBLE_TAP_MS = 320;
  var SETTLE_MS = 360; /* --dur-3 (320ms) + pay */

  function clamp(v, lo, hi) {
    return v < lo ? lo : v > hi ? hi : v;
  }

  /* Yatay yön çarpanı — tek kaynak base-brand.css'teki `--dir` token'ı.
     transform mantıksal değil; RTL'de ray ters yöne gider. */
  function readDir() {
    var v = getComputedStyle(document.documentElement).getPropertyValue('--dir').trim();
    if (v === '-1') return -1;
    if (v === '1') return 1;
    return document.documentElement.getAttribute('dir') === 'rtl' ? -1 : 1;
  }

  function Engine(modal) {
    this.modal = modal;
    this.track = modal.querySelector('.product-media-modal__content');
    this.dialog = modal.querySelector('.product-media-modal__dialog');
    this.panes = [];
    this.states = []; /* panel başına {s, x, y} */
    this.index = 0;
    this.dir = 1;
    this.paneW = 0;
    this.paneH = 0;
    this.trackX = 0;
    this.pointers = new Map();
    this.gesture = null;
    this.engaged = false;
    this.bound = false;
    this.dots = null;
    this.lastTap = 0;
    this.lastTapPoint = null;
    this.settleTimer = 0;
  }

  /* ── Kapı ──────────────────────────────────────────────────────────────── */

  Engine.prototype.canEngage = function () {
    if (!MOBILE.matches || !this.track) return false;
    var kids = Array.prototype.slice.call(this.track.children);
    if (!kids.length) return false;
    return kids.every(function (el) {
      return el.classList.contains('ewa-zoom__pane');
    });
  };

  Engine.prototype.engage = function () {
    if (this.engaged || !this.canEngage()) return;

    /* Varyant swatch'larının paneli CSS'te gizli — raya da girmemeli. */
    this.panes = Array.prototype.slice.call(this.track.children).filter(function (el) {
      return !el.classList.contains('product__media-item--variant');
    });
    if (!this.panes.length) return;

    this.engaged = true;
    this.dir = readDir();
    this.track.classList.add('ewa-zoom');

    this.states = this.panes.map(function () {
      return { s: 1, x: 0, y: 0 };
    });

    /* Başlangıç karesi Dawn'ın `.active`'inden geliyor — kullanıcı hangi
       fotoğrafa dokunduysa o. */
    var active = this.panes.findIndex(function (p) {
      return p.classList.contains('active');
    });
    this.index = active < 0 ? 0 : active;

    this.buildDots();
    this.bind();

    /* Ölçüm sınıf uygulandıktan SONRA alınmalı; kutu ölçüleri ancak o an oturuyor. */
    this.measure();
    this.warm();
    this.applyAllPanes(false);
    this.goTo(this.index, false);
  };

  Engine.prototype.disengage = function () {
    if (!this.engaged) return;
    this.engaged = false;
    this.pointers.clear();
    this.gesture = null;
    this.track.classList.remove('ewa-zoom');
    this.panes.forEach(function (pane) {
      pane.style.transform = '';
      pane.classList.remove('is-railing');
      var img = pane.querySelector('img');
      if (img) {
        img.style.transform = '';
        img.classList.remove('is-settling');
      }
    });
    if (this.dots) {
      this.dots.remove();
      this.dots = null;
    }
  };

  /* ── Ölçüm ve uygulama ─────────────────────────────────────────────────── */

  Engine.prototype.measure = function () {
    this.paneW = this.track.clientWidth;
    this.paneH = this.track.clientHeight;
  };

  /* Yakınlaştırılmış görselin panelde gezebileceği sınır. `object-fit: contain`
     olduğu için boyanan kutu panelden küçük olabilir — sınır ELEMANDAN değil
     boyanan kutudan çıkar, yoksa boş kenarlara doğru kayıyor. */
  Engine.prototype.bounds = function (i) {
    var st = this.states[i];
    var img = this.panes[i].querySelector('img');
    var nw = (img && img.naturalWidth) || 0;
    var nh = (img && img.naturalHeight) || 0;
    var cw = this.paneW;
    var ch = this.paneH;
    if (nw > 0 && nh > 0 && this.paneW > 0 && this.paneH > 0) {
      var fit = Math.min(this.paneW / nw, this.paneH / nh);
      cw = nw * fit;
      ch = nh * fit;
    }
    return {
      x: Math.max(0, (cw * st.s - this.paneW) / 2),
      y: Math.max(0, (ch * st.s - this.paneH) / 2)
    };
  };

  Engine.prototype.clampState = function (i) {
    var st = this.states[i];
    var b = this.bounds(i);
    st.x = clamp(st.x, -b.x, b.x);
    st.y = clamp(st.y, -b.y, b.y);
  };

  Engine.prototype.applyPane = function (i, animate) {
    var img = this.panes[i] && this.panes[i].querySelector('img');
    if (!img) return;
    var st = this.states[i];
    img.classList.toggle('is-settling', !!animate);
    img.style.transform = 'translate3d(' + st.x + 'px,' + st.y + 'px,0) scale(' + st.s + ')';
    if (animate) this.scheduleClear(img, 'is-settling');
  };

  Engine.prototype.applyAllPanes = function (animate) {
    for (var i = 0; i < this.panes.length; i++) this.applyPane(i, animate);
  };

  /* Kırpma kutusu (içerik elemanı) YERİNDE DURUR; kayan şey panellerin kendisi.
     İçerik elemanına translate uygularsan `overflow: hidden` penceresi de onunla
     birlikte gider ve görünür kare pencerenin dışında kalır — ilk sürüm tam olarak
     buna patladı. */
  Engine.prototype.applyRail = function (animate) {
    for (var i = 0; i < this.panes.length; i++) {
      var pane = this.panes[i];
      var offset = i * this.paneW * this.dir + this.trackX;
      pane.classList.toggle('is-railing', !!animate);
      pane.style.transform = 'translate3d(' + offset + 'px,0,0)';
      if (animate) this.scheduleClear(pane, 'is-railing');
    }
  };

  Engine.prototype.scheduleClear = function (el, cls) {
    clearTimeout(el._ewaClear);
    el._ewaClear = setTimeout(function () {
      el.classList.remove(cls);
    }, SETTLE_MS);
  };

  Engine.prototype.restX = function (i) {
    return -i * this.paneW * this.dir;
  };

  Engine.prototype.goTo = function (i, animate) {
    var next = clamp(i, 0, this.panes.length - 1);
    var changed = next !== this.index;
    this.index = next;

    /* Terk edilen kare 1×'e dönmeli — geri gelindiğinde kaldığı yakınlıkta
       açılması şaşırtıcı olur, telefon galerileri de sıfırlar. */
    if (changed) {
      for (var j = 0; j < this.states.length; j++) {
        if (j === this.index) continue;
        var st = this.states[j];
        if (st.s !== 1 || st.x !== 0 || st.y !== 0) {
          st.s = 1;
          st.x = 0;
          st.y = 0;
          this.applyPane(j, false);
        }
      }
      this.warm();
      this.syncActiveClass();
    }

    this.trackX = this.restX(this.index);
    this.applyRail(animate);
    this.updateDots();
  };

  /* Ray dışındaki panellerin görseli `loading="lazy"` — transform ile ekran
     dışında durdukları için tarayıcı onları hiç istemiyor ve kaydırınca boş
     kare görünüyor. Komşuları elle ısıt. */
  Engine.prototype.warm = function () {
    for (var i = this.index - 1; i <= this.index + 1; i++) {
      var pane = this.panes[i];
      if (!pane) continue;
      var img = pane.querySelector('img');
      if (img && img.loading === 'lazy') img.loading = 'eager';
    }
  };

  /* Dawn'ın `.active` sınıfı motor açıkken görünürlüğü belirlemiyor ama tek
     doğruluk kaynağı o — modal kapanıp yeniden açılırsa başlangıç karesi
     buradan okunuyor. */
  Engine.prototype.syncActiveClass = function () {
    var current = this.panes[this.index];
    this.modal.querySelectorAll('[data-media-id]').forEach(function (el) {
      if (el !== current) el.classList.remove('active');
    });
    if (current) current.classList.add('active');
  };

  /* ── Gösterge ──────────────────────────────────────────────────────────── */

  Engine.prototype.buildDots = function () {
    if (this.panes.length < 2 || !this.dialog) return;
    var wrap = document.createElement('div');
    wrap.className = 'ewa-zoom__dots';
    wrap.setAttribute('aria-hidden', 'true');
    var pill = document.createElement('span');
    pill.className = 'ewa-zoom__dots-pill';
    for (var i = 0; i < this.panes.length; i++) {
      var dot = document.createElement('span');
      dot.className = 'ewa-zoom__dot';
      pill.appendChild(dot);
    }
    wrap.appendChild(pill);
    this.dialog.appendChild(wrap);
    this.dots = wrap;
  };

  Engine.prototype.updateDots = function () {
    if (!this.dots) return;
    var kids = this.dots.querySelectorAll('.ewa-zoom__dot');
    for (var i = 0; i < kids.length; i++) kids[i].classList.toggle('is-current', i === this.index);
    this.dots.classList.toggle('is-dimmed', this.states[this.index].s > 1.02);
  };

  /* ── Jestler ───────────────────────────────────────────────────────────── */

  Engine.prototype.bind = function () {
    if (this.bound) return;
    this.bound = true;
    this.track.addEventListener('pointerdown', this.onDown.bind(this));
    this.track.addEventListener('pointermove', this.onMove.bind(this));
    this.track.addEventListener('pointerup', this.onUp.bind(this));
    this.track.addEventListener('pointercancel', this.onUp.bind(this));
    /* Sürüklenen görselin tarayıcı "resmi sürükle" davranışına kapılmaması. */
    this.track.addEventListener('dragstart', function (e) {
      e.preventDefault();
    });
  };

  Engine.prototype.onDown = function (e) {
    if (!this.engaged) return;
    if (e.pointerType === 'mouse' && e.button !== 0) return;

    try {
      this.track.setPointerCapture(e.pointerId);
    } catch (err) {
      /* yakalama başarısız olursa jest yine çalışır, sadece parmak elemandan
         çıkarsa kopar — engel değil */
    }
    this.pointers.set(e.pointerId, { x: e.clientX, y: e.clientY, t: e.timeStamp });

    if (this.pointers.size === 1) {
      this.gesture = {
        mode: null, /* 'pan' | 'swipe' | 'still' */
        x0: e.clientX,
        y0: e.clientY,
        t0: e.timeStamp,
        lastX: e.clientX,
        lastT: e.timeStamp,
        vx: 0,
        trackX0: this.trackX,
        panX0: this.states[this.index].x,
        panY0: this.states[this.index].y,
        edgeSlop: 0,
        handoverX: 0,
        handedOver: false
      };
    } else if (this.pointers.size === 2) {
      this.startPinch();
    }
  };

  /* Çapa hesabında referans kutu RAYIN KENDİSİ, panel değil. Panel kare geçişi
     sırasında transform altında olabiliyor; kırpma kutusu ise hiç kıpırdamıyor.
     Duran karede ikisi zaten çakışık — bu seçim yalnız geçiş anındaki kaymayı
     eliyor. */
  Engine.prototype.startPinch = function () {
    var pts = Array.from(this.pointers.values());
    var st = this.states[this.index];
    var rect = this.track.getBoundingClientRect();
    var mid = {
      x: (pts[0].x + pts[1].x) / 2 - rect.left,
      y: (pts[0].y + pts[1].y) / 2 - rect.top
    };
    var d = Math.hypot(pts[0].x - pts[1].x, pts[0].y - pts[1].y);
    this.gesture = {
      mode: 'pinch',
      rect: rect,
      d0: Math.max(1, d),
      s0: st.s,
      x0: st.x,
      y0: st.y,
      mid0: mid
    };
  };

  Engine.prototype.onMove = function (e) {
    if (!this.engaged || !this.pointers.has(e.pointerId) || !this.gesture) return;
    var p = this.pointers.get(e.pointerId);
    p.x = e.clientX;
    p.y = e.clientY;
    p.t = e.timeStamp;

    if (this.pointers.size >= 2) {
      if (this.gesture.mode !== 'pinch') this.startPinch();
      this.doPinch();
      return;
    }
    this.doDrag(e);
  };

  Engine.prototype.doPinch = function () {
    var g = this.gesture;
    var pts = Array.from(this.pointers.values());
    var st = this.states[this.index];

    var d = Math.max(1, Math.hypot(pts[0].x - pts[1].x, pts[0].y - pts[1].y));
    var s = clamp(g.s0 * (d / g.d0), 1, MAX_SCALE);

    var mid = {
      x: (pts[0].x + pts[1].x) / 2 - g.rect.left,
      y: (pts[0].y + pts[1].y) / 2 - g.rect.top
    };

    /* Parmakların ortasındaki İÇERİK noktası sabit kalsın:
       ekran = merkez + çeviri + nokta*ölçek  →  nokta = (ekran − merkez − çeviri)/ölçek */
    var cx = this.paneW / 2;
    var cy = this.paneH / 2;
    var anchorX = (g.mid0.x - cx - g.x0) / g.s0;
    var anchorY = (g.mid0.y - cy - g.y0) / g.s0;

    st.s = s;
    st.x = mid.x - cx - anchorX * s;
    st.y = mid.y - cy - anchorY * s;
    this.clampState(this.index);
    this.applyPane(this.index, false);
    this.updateDots();
  };

  Engine.prototype.doDrag = function (e) {
    var g = this.gesture;
    if (g.mode === 'pinch') return;

    var dx = e.clientX - g.x0;
    var dy = e.clientY - g.y0;

    var dt = e.timeStamp - g.lastT;
    if (dt > 0) g.vx = (e.clientX - g.lastX) / dt;
    g.lastX = e.clientX;
    g.lastT = e.timeStamp;

    if (g.mode === null) {
      if (this.states[this.index].s > 1.02) {
        g.mode = 'pan';
      } else if (Math.abs(dx) > AXIS_LOCK && Math.abs(dx) > Math.abs(dy)) {
        g.mode = 'swipe';
      } else if (Math.abs(dy) > AXIS_LOCK) {
        g.mode = 'still'; /* dikey sürükleme yakınlaştırılmamış karede iş yapmaz */
      } else {
        return;
      }
    }

    if (g.mode === 'still') return;

    if (g.mode === 'pan') {
      var st = this.states[this.index];
      var b = this.bounds(this.index);
      var wantX = g.panX0 + dx;
      st.x = clamp(wantX, -b.x, b.x);
      st.y = clamp(g.panY0 + dy, -b.y, b.y);

      /* Kenara dayandıktan sonra aynı yöne devam = "sıradaki fotoğrafa geç".
         Telefon galerilerindeki devir teslim; olmazsa yakınlaştırılmışken
         galeri kilitleniyor. */
      g.edgeSlop = wantX - st.x;
      if (Math.abs(g.edgeSlop) > EDGE_HANDOVER) {
        g.mode = 'swipe';
        g.trackX0 = this.trackX;
        g.handoverX = e.clientX;
        g.handedOver = true;
      }
      this.applyPane(this.index, false);
      return;
    }

    /* swipe — parmak fizikselse ray da fiziksel hareket eder; yön çarpanı
       yalnız İNDEKS kararında devreye girer (aşağıda). */
    /* Devir teslimden sonra mesafe devir noktasından ölçülür. Bayrakla ayırt
       ediliyor, `handoverX` doğruluğuyla değil — ekranın sol kenarında x=0 gelir
       ve doğruluk kontrolü sessizce yanlış dala saparadı. */
    var base = g.handedOver ? e.clientX - g.handoverX : dx;
    var x = g.trackX0 + base;
    var lo = Math.min(0, this.restX(this.panes.length - 1));
    var hi = Math.max(0, this.restX(this.panes.length - 1));
    if (x < lo) x = lo + (x - lo) * 0.35;
    else if (x > hi) x = hi + (x - hi) * 0.35;
    this.trackX = x;
    this.applyRail(false);
  };

  Engine.prototype.onUp = function (e) {
    if (!this.engaged) return;
    this.pointers.delete(e.pointerId);
    try {
      this.track.releasePointerCapture(e.pointerId);
    } catch (err) {
      /* zaten serbest */
    }
    var g = this.gesture;
    if (!g) return;

    if (this.pointers.size >= 1) {
      /* İki parmaktan biri kalktı: kalan parmakla gezmeye devam. */
      var rest = Array.from(this.pointers.values())[0];
      var st = this.states[this.index];
      this.gesture = {
        mode: 'pan',
        x0: rest.x,
        y0: rest.y,
        t0: e.timeStamp,
        lastX: rest.x,
        lastT: e.timeStamp,
        vx: 0,
        trackX0: this.trackX,
        panX0: st.x,
        panY0: st.y,
        edgeSlop: 0,
        handoverX: 0,
        handedOver: false
      };
      return;
    }

    if (g.mode === 'pinch') {
      this.settleZoom();
      this.gesture = null;
      return;
    }

    var dx = e.clientX - g.x0;
    var dy = e.clientY - g.y0;
    var dur = e.timeStamp - g.t0;

    if (g.mode === 'swipe') {
      var travel = g.handedOver ? e.clientX - g.handoverX : dx;
      var far = Math.abs(travel) > this.paneW * SWIPE_RATIO;
      var fast = Math.abs(g.vx) > SWIPE_VELOCITY;
      var step = 0;
      if ((far || fast) && travel !== 0) {
        /* Parmak sola → LTR'de sonraki, RTL'de önceki. Yön çarpanı tam burada. */
        step = (travel < 0 ? 1 : -1) * this.dir;
      }
      this.goTo(this.index + step, true);
      this.gesture = null;
      return;
    }

    if (g.mode === 'pan') {
      this.settleZoom();
      this.gesture = null;
      return;
    }

    /* Hareketsiz bırakma = dokunuş. Çift dokunuşu burada yakala. */
    if (Math.abs(dx) < TAP_SLOP && Math.abs(dy) < TAP_SLOP && dur < TAP_MS) {
      this.handleTap(e);
    }
    this.gesture = null;
  };

  Engine.prototype.handleTap = function (e) {
    var now = e.timeStamp;
    var near =
      this.lastTapPoint &&
      Math.abs(e.clientX - this.lastTapPoint.x) < 40 &&
      Math.abs(e.clientY - this.lastTapPoint.y) < 40;

    if (now - this.lastTap < DOUBLE_TAP_MS && near) {
      this.lastTap = 0;
      this.lastTapPoint = null;
      this.toggleZoomAt(e.clientX, e.clientY);
      return;
    }
    this.lastTap = now;
    this.lastTapPoint = { x: e.clientX, y: e.clientY };
  };

  Engine.prototype.toggleZoomAt = function (clientX, clientY) {
    var st = this.states[this.index];
    if (st.s > 1.02) {
      st.s = 1;
      st.x = 0;
      st.y = 0;
    } else {
      var rect = this.track.getBoundingClientRect();
      var px = clientX - rect.left - this.paneW / 2;
      var py = clientY - rect.top - this.paneH / 2;
      /* 1×'ten büyütürken çapa noktası doğrudan dokunulan yer: x = p(1 − s) */
      st.s = TAP_SCALE;
      st.x = px * (1 - TAP_SCALE);
      st.y = py * (1 - TAP_SCALE);
    }
    this.clampState(this.index);
    this.applyPane(this.index, true);
    this.updateDots();
  };

  Engine.prototype.settleZoom = function () {
    var st = this.states[this.index];
    if (st.s <= 1.02) {
      st.s = 1;
      st.x = 0;
      st.y = 0;
      this.applyPane(this.index, true);
    } else {
      var before = st.x + ',' + st.y;
      this.clampState(this.index);
      this.applyPane(this.index, before !== st.x + ',' + st.y);
    }
    this.updateDots();
  };

  /* ── Modal yaşam döngüsü ───────────────────────────────────────────────── */

  /* Kapanışta galeriyi son bakılan kareye getir: kullanıcı tam ekranda kaydırıp
     çıkınca galeride başka bir fotoğraf görmek kopukluk yaratıyor. */
  Engine.prototype.syncGalleryOnClose = function () {
    if (!this.engaged) return;
    var pane = this.panes[this.index];
    var section = this.modal.dataset.section || this.modal.id.replace('ProductModal-', '');
    if (!pane || !section) return;
    var gallery = document.querySelector('media-gallery');
    if (!gallery || typeof gallery.setActiveMedia !== 'function') return;
    try {
      gallery.setActiveMedia(section + '-' + pane.dataset.mediaId, false);
    } catch (err) {
      /* galeri tek medyalıysa ya da hedef bulunamazsa sessizce geç */
    }
  };

  function engineFor(modal) {
    if (!modal.__ewaZoom) modal.__ewaZoom = new Engine(modal);
    return modal.__ewaZoom;
  }

  function onOpenChange(modal) {
    var engine = engineFor(modal);
    var open = modal.hasAttribute('open');

    /* Sohbet balonunu modalın arkasına iten kanca — motor kapısının DIŞINDA,
       çünkü modal masaüstünde ve video'lu üründe de açılıyor. Karşılığı
       pdp-zoom.css'teki `html.ewa-media-modal-open shopify-chat`. */
    document.documentElement.classList.toggle('ewa-media-modal-open', open);

    if (open) {
      engine.engage();
    } else {
      engine.syncGalleryOnClose();
      engine.disengage();
    }
  }

  /* `show()` önce `open` niteliğini koyuyor, sonra `showActiveMedia()`'yı
     çağırıyor. MutationObserver geri çağrısı o görev bittikten sonra düştüğü
     için `.active` okunmaya hazır oluyor — kurulum sırasına bağımlılık yok. */
  var observer = new MutationObserver(function (records) {
    for (var i = 0; i < records.length; i++) {
      var el = records[i].target;
      if (el.matches && el.matches('product-modal.product-media-modal')) onOpenChange(el);
    }
  });

  function watch() {
    observer.observe(document.documentElement, {
      subtree: true,
      attributes: true,
      attributeFilter: ['open']
    });
    document.querySelectorAll('product-modal.product-media-modal[open]').forEach(onOpenChange);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watch);
  else watch();

  /* Ekran döndürme / breakpoint geçişi: açıkken ölçüler değişirse ray kayar. */
  window.addEventListener('resize', function () {
    document.querySelectorAll('product-modal.product-media-modal[open]').forEach(function (modal) {
      var engine = modal.__ewaZoom;
      if (!engine) return;
      if (!MOBILE.matches) {
        engine.disengage();
        return;
      }
      if (!engine.engaged) {
        engine.engage();
        return;
      }
      engine.measure();
      engine.states.forEach(function (st, i) {
        engine.clampState(i);
      });
      engine.applyAllPanes(false);
      engine.trackX = engine.restX(engine.index);
      engine.applyRail(false);
    });
  });
})();
